import React from "react";
import PropTypes from "prop-types";
import "./dashButton.css";

const DashButton = ({ label, onClick, disabled, variant }) => {
  return (
    <button 
      className={`dash-button ${variant}`} 
      onClick={onClick} 
      disabled={disabled}
    >
      {label}
    </button>
  );
};

// Define expected props
DashButton.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  variant: PropTypes.string, 
};

DashButton.defaultProps = {
  disabled: false,
  variant: "primary",
};

export default DashButton;
